import { render, staticRenderFns } from "./AddStudentInfo.vue?vue&type=template&id=38f512da&scoped=true&"
import script from "./AddStudentInfo.vue?vue&type=script&lang=js&"
export * from "./AddStudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentInfo.vue?vue&type=style&index=0&id=38f512da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f512da",
  null
  
)

export default component.exports